import { Link } from 'react-router-dom';
import { categoryEntries } from '@/mocks/categories';

export default function CategoryQuickEntry() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {categoryEntries.map((entry) => (
        <Link
          key={entry.key}
          to={`/category?type=${encodeURIComponent(entry.type ?? '')}&region=${encodeURIComponent(entry.region ?? '')}`}
          className="group flex flex-col items-center text-center gap-3 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/40 transition-colors cursor-pointer"
        >
          <span className="w-12 h-12 md:w-14 md:h-14 rounded-md bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 flex items-center justify-center transition-colors">
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <div>
            <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">{entry.label}</h3>
            <p className="mt-1 text-xs font-label text-foreground-500 line-clamp-2">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}